import { Autocomplete, Avatar, Button, CircularProgress, TextField } from "@mui/material"
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { fontSize_15, fontSize_20, fontSize_32, fontSize_headings, maxWidth } from "../../../shared/styleconfig"
import { BLOG_CATEGORY } from "../../../shared/constant"
import { ReactComponent as SecureIcon } from '../../../assets/image/icons/secure.svg';
import { useConfirm } from "material-ui-confirm";
import profilePic from '../../../assets/image/profile/profilePic.png'
import { useEffect, useMemo, useState } from "react";
import Supabase from "../../../backend/client";
import { errorToaster } from "../../../util/toaster";
import moment from "moment";
import { useUser } from '../../../context/UserContext'
import { useNavigate } from "react-router-dom";
import BuySimmulation from "./BuySimmulation";

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

const deleteAlgo = async (item, getAlgos) => {
    const { error } = await Supabase
    .from('algos')
    .update({ isDeleted: true })
    .eq('id', item?.id)
    .select();

    getAlgos()
}

const AlgoCard = ({
    item,
    index,
    setShowPopup,
    getAlgos,
    user,
    setSelectedAlgo,
    type,
    cart,
    getMyStocks,
    personalAlgos,
    setUpdateStocks
}) => {
    const confirm = useConfirm();
    const navigate = useNavigate();
    const [open,setOpen] = useState(false);

    const backtestResult = JSON.parse(item?.backtest_details)

    const handleClick = () => {
        confirm({ description: "Are you sure you want to delete this Algo.?" })
          .then(() => {
            deleteAlgo(item, getAlgos)
          })
          .catch(() => {
            console.log('error');
          });
      };

      const getButton = (status) => {
        let cartIdsOfUser = cart
        if(personalAlgos){
            return <button className="bg-[#001639] w-[120px] h-[45px] text-white rounded-[25px] text-xs" onClick={() => {
                navigate(`/algo/edit/${item?.id}`)
            }} >
                Edit Algo
            </button>
        }
        if(cartIdsOfUser.indexOf(item?.id) > -1) {
            return <button className="bg-[#001639] disabled:bg-[#00163950] w-[120px] h-[45px] text-white rounded-[25px] text-xs" disabled>
            Subscribed
        </button>
        }
        else if(status === 'Draft' ){
            return <button className="bg-[#001639] w-[120px] h-[45px] text-white rounded-[25px] text-xs" onClick={() => {
                navigate(`/algo/edit/${item?.id}`)
            }} >
                Edit Algo
            </button>
         }
         else {
            return <button className="bg-[#001639] disabled:bg-[#00163950] w-[120px] h-[45px] text-white rounded-[25px] text-xs" onClick={() => setOpen(true)} disabled={user?.user?.id === item?.user_id}>
            Rent: ${item?.algo_price}/m
        </button>
         }
        }
    const mapper = {
        Publish: "Published",
        Draft: "Draft",
        Private: "Private"
    }

    return (
        <>
            <div key={index} className="flex flex-col w-[300px] font-[Helvetica LT Std] my-2.5" >
                <div className={`flex flex-col bg-${ (item?.status  === 'Draft' || type === 'Cart' || item?.status  === 'Private') ? `[#0061FC]` : `[#001639]`} rounded-t-[20px]`}>
                    <div className="flex flex-row border-b border-b-solid border-b-[#FFFFFF50] px-[28px] pt-[28px] pb-[20px] justify-between relative">
                        <div className="flex flex-col">
                            <p className={`${fontSize_15} text-white`}>Win Rate</p>
                            <p className={`xs:text-[20px] sm:text-[30px] text-white font-bold`}>{backtestResult?.winRate}<sup>%</sup></p>
                        </div>
                        <div className="flex flex-col items-center justify-start">
                            <div className="flex flex-row gap-[10px]"><div className="text-[10px] text-[#FFEB00] border border-solid border-[#FFEB00] rounded-[10px] w-[65px] text-center">{mapper[item?.status]}</div><SecureIcon className="w-[15px] h-auto"/></div>
                            <div className={`${fontSize_32} text-[#FFEB00] font-bold leading-[25px] mt-[40px]`}>{backtestResult?.pnl}% PL</div>
                        </div>
                        { !personalAlgos ? user?.user?.id === item?.user_id && item.status !== 'Publish' && <HtmlTooltip title={<div>Delete</div>} ><button className={`bg-[#001639] !text-white font-bold w-[20px] h-[20px] rounded-[100%] text-xs absolute right-[8px] top-[8px]`} onClick={() => handleClick()}>
                        X
                        </button></HtmlTooltip> : <HtmlTooltip title={<div>Delete</div>} ><button className={`bg-[#001639] !text-white font-bold w-[20px] h-[20px] rounded-[100%] text-xs absolute right-[8px] top-[8px]`} onClick={() => handleClick()}>
                        X
                        </button></HtmlTooltip>}
                    </div>

                    <div className="flex flex-col px-[30px] py-[20px] gap-[15px]">
                        <h3 className={`${fontSize_32} text-[#FFFFFF] font-bold leading-[25px]`}>{item?.title}</h3>
                        <p className={`text-[12px] text-[#FFFFFF] font-[100] leading-[16px] pr-[37px]`}>
                            {item?.description?.length || item?.title?.length > 10 ?<div className="text-[12px] text-[#FFFFFF] font-[100] leading-[16px] pr-[37px] flex" > <div className="truncate w-[100px]" >{item?.description } </div> <span className="text-[#76ABFF] font-bold cursor-pointer" ><HtmlTooltip
                                title={
                                    <div className="p-4 " >
                                        <p className="text-[14px] font-bold" > {item?.title} </p>
                                        <p className="text-[grey]" > {item?.description} </p>
                                    </div>
                                }
                            >Read More</HtmlTooltip> </span></div> : item?.description}
                        </p>
                    </div>

                    <div className="flex flex-row px-[30px] pb-[15px] gap-[10px]">
                        <Avatar src={ item?.profiles?.avatar_url } className="w-[60px] h-[60px]"/>
                        <div className="flex flex-col">
                            <p className={`${fontSize_15} text-white font-[100]`}>{moment(item?.created_at).format('DD/MM/YYYY')}</p>
                            <p className={`${fontSize_15} text-white font-[700] leading-[16px]`}>Owner: <br />{item?.profiles?.full_name || 'N/A'}</p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-between bg-[#F2F2F2] rounded-b-[20px] px-[30px] py-[15px]">
                    
                    {getButton(item?.status)}
                    <button className="bg-[#001639] w-[45px] h-[45px] text-white rounded-[100%]" onClick={() => {
                        setSelectedAlgo(item)
                        setShowPopup(true)
                    }}>+</button>
                </div>
            </div>
            {
                open ? 
                <BuySimmulation 
                    open={open}
                    handleClose={() => {
                        getMyStocks()
                        setOpen(false)
                    }}
                    algoDetail={item}
                />
                : ""
            }
            
        </>
    )
}

export const AlgoCollection = ({setShowPopup, type, setSelectedAlgo, cart, getMyStocks, personalAlgos= false, setUpdateStocks, updateStocks}) => {
    const [algoList, setAlgoList] = useState([]);
    const [algoListClone, setAlgoListClone] = useState([]);
    const [loader, setLoader] = useState(true)
    const user = useUser();
    const userId = localStorage?.getItem("userId")

    const getAlgos = async () => {
        try{
            const {data, error} = await Supabase.from('algos').select("id, created_at, algo_custom_id, user_id, username, left_logic, right_logic, algo_price, used_counter, title, description, status, backtest_details, isDeleted, profiles ( id, avatar_url, full_name )").eq("isDeleted", false);
            if(error){
                return errorToaster(error.message)
            }
            if(type === 'Draft') {
                setAlgoList(data.filter((item) => item.user_id === userId))
                setAlgoListClone(data.filter((item) => item.user_id === userId))
            }
            else if(type === 'Cart') {
                let { data: my_stock_cart, error } = await Supabase.from("my_stock_cart")
                .select("algo_id")
                .eq("user_id", userId);
                console.log(my_stock_cart)
                let cartIds = [...new Set(my_stock_cart?.map((item) => item.algo_id))]
                const algosData= data.filter((item) => cartIds.indexOf(item.id) > -1)

                console.log(algosData, cartIds);
                setAlgoList(algosData)
                setAlgoListClone(algosData)
            }
            else {
                setAlgoList(data.filter((item) => item.status === type))
                setAlgoListClone(data.filter((item) => item.status === type))
            }
        }
        catch(error){
            errorToaster(error?.message)
        }
        finally{
            setLoader(false)
        }
    }

    useEffect(()=> {
        setLoader(true)
        getAlgos()
    },[])

    useMemo(() => {
        console.log("memo called")
        getAlgos()
    },[updateStocks])
    

    return (
        <div className={`flex flex-col w-[80%] ${maxWidth} mx-auto mt-[50px] gap-[20px]`}>
            <div className="flex lg:flex-row xs:flex-col lg:justify-start xs:justify-center items-center">
                <h3 className={`${fontSize_headings} flex-1`}>{type === 'Draft' ? 'My Algos' : type === 'Cart' ? "My Subscriptions" : 'Trending Algos'}</h3> 
                <div className='xs:flex-1 sm:flex-1 lg:flex-[0.5] flex' >
                    <TextField
                        name="search"
                        placeholder='Search'
                        type='search'
                        fullWidth
                        onChange={(e) => {
                            let searchVal = e.target.value.toLowerCase();
                            let searchedArray = algoListClone.filter((item) => {
                                if(item?.title?.toLowerCase()?.includes(searchVal) || item?.username?.toLowerCase().includes(searchVal)) {
                                    return item;
                                }
                            })
                            setAlgoList(searchedArray)                      
                        }}
                    />
                </div>
            </div>

            <div className="flex flex-row flex-wrap gap-[10px] lg:justify-start xs:justify-center">
                {loader ? <div className="flex-1 text-center" >
                        <CircularProgress />
                        <p>
                            Loading ...
                        </p>
                    </div> : algoList?.length > 0 ? algoList?.map((item, index) => {
                            if(type === 'Publish' ){
                                if(user?.user?.id !== item?.user_id){
                                    return <AlgoCard key={index} setUpdateStocks={setUpdateStocks} personalAlgos={personalAlgos} getMyStocks={getMyStocks} item={item} index={index} setShowPopup={setShowPopup} getAlgos={getAlgos} user={user} setSelectedAlgo={setSelectedAlgo} type={type} cart={cart}/>
                                }
                                return
                            }
                            return <AlgoCard setUpdateStocks={setUpdateStocks} personalAlgos={personalAlgos} getMyStocks={getMyStocks} item={item} index={index} setShowPopup={setShowPopup} getAlgos={getAlgos} user={user} setSelectedAlgo={setSelectedAlgo} type={type} cart={cart}/>
                        
                    }) : <div className="flex-1 text-center" ><p>No Algos Found.</p></div>}
            </div>

            {
                // algoList?.length > 12 ? 
                <div className="flex flex-col p-[50px] items-center justify-center">
                    {/* <button className='py-5 px-10 border-[#B9B9B9] border-2 rounded-full text-[#B9B9B9] font-bold' onClick={() => alert('In Progress')}>
                        Load More
                    </button> */}
                </div>
                // : ''
            }
           
        </div>
    )
}